import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
cardRoot: {
    marginBottom: theme.spacing.unit,
    cursor: 'pointer',
},
createDialogWrapper: {
    padding: theme.spacing.unit,
},
cardContentRoot: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    '&:last-child': {
        paddingBottom: theme.spacing.unit * 2,
    },
    textAlign: 'center',
},
cardImage: {
    width: '120px',
    minHeight: '120px',
    marginBottom: theme.spacing.unit * 2,
},
dropDownItems: {
    paddingLeft: '15px'
},
selectGoale: {
    paddingTop: '15px'
},
selectFiles: {
    paddingTop: '10px',
    color: '#42a5f5'
},
btnAlign: {
    marginTop: '15px',
    float: 'right'
},
bodyColor: {
    backgroundColor: 'white'
},
headerLeft: {
    float:"left",
    fontSize: '20px'
},
marginLeft15: {
    marginLeft: '15px'
},
marginTop20: {
    marginTop: '20px'
},
cardContainer: {
    border: "1px solid #ffffff",
    boxSizing: "border-box",
    borderRadius: "4px"
},
searchWrapper: {
    paddingTop: "15px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingBottom: "15px",
},
borderSelected: {
    background: "#FBFBFB",
    border: "2px solid #0698EC",
    boxSizing: "border-box",
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.252774)"
},
tickIcon: {
    position: "absolute",
    height: "30px",
    width: "30px",
    marginTop: "10px",
    marginLeft: "10px"
},
tickIconHide:{
    display:"none",
    position: "absolute",
    height: "30px",
    width: "30px",
},
hideButton:{
    display:"none"
}
});